<template>
    <div class="queue-wait-time-select">
        <div class="input go" v-if="isMobile" @click="showWaitTime = true">
            {{ timeTitle }}
            <img src="@/assets/img/next-green.png">
        </div>
        <div class="select" v-else>
            <select class="time" v-model="time" @change="onChange">
                <option v-for="val in times" :value="val.value" :key="val.value">{{ val.title }}</option>
            </select>
        </div>
        <set-accompanying-time-select v-if="showWaitTime" :hours="value" @onDone="setTime"/>
    </div>
</template>

<script>
    import SetAccompanyingTime from "./order/SetAccompanyingTime";

    export default {
        name: 'AccompanyingWaitTimeSelect',
        components: {
            'set-accompanying-time-select': SetAccompanyingTime,
        },
        data() {
            return {
                timeTitle: '1小時',
                showWaitTime: false,
                time: null,
                times: [{value: 2, title: '2小時'},{value: 3, title: '3小時'},{value: 4, title: '4小時'},{value: 5, title: '5小時'},{value: 6, title: '6小時'},{value: 7, title: '7小時'},{value: 8, title: '8小時'},{value: 9, title: '9小時'},{value: 10, title: '10小時'},{value: 11, title: '11小時'},{value: 12, title: '12小時'}],
            }
        },
        props: {
            value: {
                default: {},
                required: true,
            }
        },
        model: {
            prop: 'value',
            event: 'input',
        },
        computed: {
            isMobile() {
                if(! /AppleWebKit.*Mobile/i.test(navigator.userAgent) &&
                    ! /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent) &&
                    ! /Android|webOS|iPhone|iPod|BlackBerry|iPad/i.test(navigator.userAgent)){
                    return false;
                }

                return true;
            },
        },
        methods: {
            initValue() {
                this.time = this.value;
                this.initTitle(this.value);
            },
            initTitle(hours) {
                this.timeTitle = `${hours} 小時`;
            },
            onChange() {
                this.$emit('input', parseFloat(this.time));
            },
            setTime(hours) {
                this.showWaitTime = false;
                this.initTitle(hours);
                this.$emit('input', hours);
            },
        },
        created() {
            this.initValue();
        },
        watch: {
            value() {
                this.initValue();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .queue-wait-time-select {
        .select {
            height: 21px;
        }
        .input {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            text-align: right;
            color: rgba(51,153,51,1);
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
        }
    }
    select {
        border: none;
        background: none;
        font-size: 16px !important;
        text-align-last: right;
        color: rgba(51,153,51,1);
        height: 20px !important;
        min-width: 114px;

        option {
            height: 20px;
        }

        &.time {
            min-width: 88px;
        }
    }
</style>
